import { projectRequest } from 'api';

interface IDeleteAnnouncementArgs {
  id: string;
}

const deleteAnnouncement = (args: IDeleteAnnouncementArgs) => {
  const { id } = args;
  return projectRequest(false, 'v2').delete(`/announcement/${id}`);
};

export default deleteAnnouncement;
